<template>
  <div class="directions-view" role="presentation">
    <h3 v-if='poi' class='name-of-poi main-color'>{{ $tr(poi.name) }}<span style="color:grey;"> &middot; {{$store.state.college.name}}</span></h3>
    <div class="btn-container" role="presentation">
      <button class="btn main-background secondary-text direction btn-border btn-start-tour"
           :disabled="position === undefined" @click="showRoute = true">
           <i aria-hidden="true" class="material-icons" :class="{active: showRoute}">navigation</i>{{ $t("poiView.startTour") }}
      </button>
    </div>
    <GeoLocationNotification />
    <poi-map :poiList="[poi]"
             :center="{ lat: poi.lat, lng: poi.lon }"
             :position="position"
             :visible="true"
             v-bind:class="{ 'directions-error': hasError }"
             @directions-error="onDirectionsError"
             :directions="showRoute"/>
    <a class='google-map-link' target="_blank" :href="googleMapLink" v-if="isExistsAddress">
      {{ poi.addressFirst }} {{ poi.city }} {{ poi.state }} {{ poi.zip_code }}
    </a>
    <div class="btn-container" role="presentation">
      <button class="btn btn-secondary main-color direction btn-border btn-list-stop"
           @click="isShowListPoi = !isShowListPoi">
           <i aria-hidden="true" class="material-icons">format_list_numbered</i>{{ $t("poiView.listStops") }}
      </button>
    </div>
    <ul v-if="isShowListPoi" class="list-poi" role="menu">
      <li class="poi-item" role="menuitem"
          :class="{ active: poi.id === stop.id, 'main-background': poi.id === stop.id}"
          v-for="(stop, index) in poiList"
          :key="stop.id">
          <button @click="selectPoi(stop.id)">
            {{index + 1}}. {{ $tr(stop.name) }}
          </button>
      </li>
      <li class="list-empty" v-if="poiList.length === 0">{{ $t("poiView.listEmpty") }}</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PoiMap from '@/components/PoiMap'
import GeoLocationNotification from '@/components/GeoLocationNotification'

export default {
  name: 'PoiDirections',
  components: {
    PoiMap,
    GeoLocationNotification
  },
  data () {
    return {
      isMapOpen: true,
      isShowListPoi: false,
      showRoute: false,
      hasError: false
    }
  },
  methods: {
    selectPoi: function (idPoi) {
      this.$router.push({ name: this.$route.name, params: { id: idPoi } })
    },
    onDirectionsError: function () {
      this.hasError = true
    }
  },
  computed: {
    ...mapState('poi', {
      poi: state => state.currentPoi,
      poiList: state => state.currentPoiList
    }),
    ...mapGetters({
      position: 'getUserPosition'
    }),
    googleMapLink: function () {
      // Fail-safe measure to guarantee we don't send any null or undefined values to Google
      const address = this.poi.addressFirst || ''
      const city = this.poi.city || ''
      const state = this.poi.state || ''
      const zip = this.poi.zip_code || ''

      return encodeURI(`https://www.google.com/maps/?q=${address} ${city} ${state} ${zip}`)
    },
    isExistsAddress () { return this.poi.addressFirst || this.poi.city || this.poi.state || this.poi.zip_code }
  },
  watch: {
    $route: function (newVal, oldVal) {
      this.showRoute = false
      this.isShowListPoi = false
      this.hasError = false
    }
  }
}
</script>
